<script setup lang="js">

import QuestionService from "@/services/question.service.js";
import { useAuthStore } from "@/stores/auth";
import { onMounted, ref, watch } from "vue";

const models = [
  // {
  //   'name': 'GPT',
  //   'icon': 'gpt-icon.png'
  // },
  {
    'name': 'GEMINI',
    'icon': 'gemini-icon.png'
  }
];

const selectedModel = ref(models[0]);

const feedbackUrl = ref(null);

const emit = defineEmits(['update:selectedModel']);

const auth = useAuthStore();

function handleLogout() {
  auth.logout();
}

onMounted(() => {
  QuestionService.getFeedbackUrl()
      .then(url => feedbackUrl.value = url);
})

watch(selectedModel, (newValue) => {
  emit('update:selectedModel', newValue);
}, { immediate: true });
</script>

<template>
  <Menubar class="navbar">
    <template #start>
      <div class="navbar-logo-container">
        <img
          src="@/assets/images/logo.svg"
          alt="Gerador de itens"
          class="navbar-logo"
        />
      </div>
    </template>

    <template #end>
      <div class="flex items-center gap-2">
        <!-- <Button title="Responder pesquisa"
                v-if="feedbackUrl"
                as="a"
                :href="feedbackUrl"
                target="_BLANK"
                label="Responda a pesquisa"
                severity="danger"/> -->

        <Select
          v-model="selectedModel"
          :options="models"
          optionLabel="name"
          placeholder="Selecione a IA"
        >
          <template #value="slotProps">
            <div class="flex align-items-center gap-2" v-if="slotProps.value">
              <img :src="`/${slotProps.value.icon}`" alt="Model logo" />
              <span>{{ slotProps.value.name }}</span>
            </div>
            <span v-else>Selecione a IA</span>
          </template>

          <template #option="slotProps">
            <div class="flex align-items-center gap-2">
              <img :src="`/${slotProps.option.icon}`" alt="Model logo" />
              <span>{{ slotProps.option.name }}</span>
            </div>
          </template>
        </Select>

        <Button
          label="Sair"
          icon="pi pi-sign-out"
          severity="secondary"
          text
          rounded
          class="ml-2"
          aria-label="Sair"
          v-if="auth.isAuthenticated"
          @click="handleLogout"
        />
      </div>
    </template>
  </Menubar>
</template>

<style scoped>
.navbar-logo-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-logo {
  height: 2rem;
  width: auto;
  max-height: 2rem;
}
</style>
